// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemCollection_container__9G2Vv"};